import type { LoanFinancialSnapshotV1 } from './loan-financial.types';
import { formatBusinessDate, formatMoneyAr } from './loan-financial.format';
import { SectionCard } from './LoanUiBits';

type Props = { snap: LoanFinancialSnapshotV1 };

export function LoanOverdueSummary({ snap }: Props) {
  const asOf = formatBusinessDate(snap.asOf);
  const total = Number(snap.overdue.total ?? 0);
  const count = Number(snap.overdue.installmentCount ?? 0);

  return (
    <SectionCard title={`Deuda vencida al ${asOf}`}>
      {total <= 0 ? (
        <p className="text-sm text-emerald-800">
          <span aria-hidden>✓</span> Sin deuda vencida
        </p>
      ) : (
        <div className="space-y-1.5 text-sm">
          <Row label="Capital vencido" value={snap.overdue.principal} />
          <Row label="Interés vencido" value={snap.overdue.interest} />
          <Row label="Cargos vencidos" value={snap.overdue.fees} />
          <Row label="Punitorios" value={snap.overdue.penalties} />
          <Row label="Total vencido" value={total} bold />
          <p className="pt-1 text-xs text-slate-500">
            Cantidad de cuotas vencidas: <strong>{count}</strong>
          </p>
        </div>
      )}
    </SectionCard>
  );
}

function Row({ label, value, bold }: { label: string; value: unknown; bold?: boolean }) {
  return (
    <div className={`flex justify-between ${bold ? 'font-semibold text-slate-900' : 'text-slate-700'}`}>
      <span>{label}</span>
      <span className="tabular-nums">{formatMoneyAr(value)}</span>
    </div>
  );
}
